import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'

import DialogContainer from '../../../../components/DialogContainer'
import DialogContent from '../../../../components/DialogContent'
import DialogTitle from '../../../../components/DialogTitle'
import IconLabel from '../../../../components/IconLabel'
import PrimaryButton from '../../../../components/PrimaryButton'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import useRouter from '../../../../hooks/useRouter'
import RemoveTeamMemberMutation from '../../../../mutations/RemoveTeamMemberMutation'

const StyledDialogContainer = styled(DialogContainer)({
  width: 356
})

const StyledButton = styled(PrimaryButton)({
  margin: '1.5rem auto 0'
})






const LeaveTeamModal = (props) => {
  const {closePortal, teamMember: teamMemberRef} = props
  const teamMember = useFragment(
    graphql`
      fragment LeaveTeamModal_teamMember on TeamMember {
        teamMemberId: id
      }
    `,
    teamMemberRef
  )
  const atmosphere = useAtmosphere()
  const {history} = useRouter()
  const {teamMemberId} = teamMember
  const handleClick = () => {
    history.push('/meetings')
    closePortal()
    RemoveTeamMemberMutation(atmosphere, {teamMemberId})
  }
  return (
    React.createElement(StyledDialogContainer, null
      , React.createElement(DialogTitle, null, 'Are you sure?')
      , React.createElement(DialogContent, null
        , 'This will remove you from the team.'
        , React.createElement('br', null )
        , 'All of your tasks will be given to the team lead.'
        , React.createElement(StyledButton, { size: "medium", onClick: handleClick,}
          , React.createElement(IconLabel, { icon: "arrow_forward", iconAfter: true, label: "Leave the team"  ,} )
        )
      )
    )
  )
}

export default LeaveTeamModal
